import React from 'react';
export function ShortTestimonials() {
  const testimonials = [{
    text: 'Me salvó el año. Llegaba a marzo sin nada armado y ahora tengo todo planificado hasta diciembre.',
    author: 'M.L., Córdoba',
    role: 'Psicopedagoga'
  }, {
    text: 'Lo mejor es que ya viene secuenciado. No tengo que pensar el orden, solo imprimir y aplicar.',
    author: 'V.R., Rosario',
    role: 'Docente de sala de 4'
  }, {
    text: 'Las rúbricas y fichas de seguimiento son un lujo. Mis informes ahora los hago en la mitad de tiempo.',
    author: 'S.G., CABA',
    role: 'Docente integradora'
  }];
  return <section className="w-full bg-transparent py-6" data-id="element-221">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-222">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-223">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#1A1A1A] p-3 rounded-lg border-l-2 border-[#D4A843]" data-id="element-224">
              <p className="text-gray-300 mb-2 italic text-xs" data-id="element-225">
                "{testimonial.text}"
              </p>
              <div className="text-[10px]" data-id="element-226">
                <div className="font-semibold text-white" data-id="element-227">
                  {testimonial.author}
                </div>
                <div className="text-[#D4A843]" data-id="element-228">{testimonial.role}</div>
              </div>
              <div className="text-[8px] text-gray-500 mt-1" data-id="element-229">EJEMPLO</div>
            </div>)}
        </div>
      </div>
    </section>;
}